import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-dashboard-menu-switcher',
    templateUrl: './dashboard-menu-switcher.component.html',
    styleUrls: ['./dashboard-menu-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardMenuSwitcherComponent implements OnInit {
  @Output() menuChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  constructor() {}

  ngOnInit(): void {}

  changeMenu(event: MatSlideToggleChange) {
    this.menuChange.emit(event.checked);
  }
}
